import Carousel from 'global/carousel.src';
import startFreeTrialForm from 'global/free-trial-form-multiple.src';
import { WistiaDialog } from 'global/simple-dialog.src';

((fn) => {
    if (document.readyState !== 'loading') {
        fn();
    } else {
        document.addEventListener('DOMContentLoaded', fn);
    }
})(() => {
    /**
     * Carousel
     */
    [].forEach.call(document.querySelectorAll('.carousel'), (item) => {
        const c = new Carousel(item);
    });

    [].forEach.call(document.querySelectorAll('.free-trial-form'), (form) => {
        startFreeTrialForm.init(form);
    });

    /** * wistia ** */
    [].forEach.call(document.querySelectorAll('.play'), (btnElem) => {
        const dialogElem = document.getElementById(btnElem.getAttribute('data-dialog-id'));
        const wistiaDialog = new WistiaDialog(dialogElem);

        btnElem.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            wistiaDialog.show();
        });
    });
});
